var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupScgSolutionsThailandLtd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.31 18.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-6a6e77 {\n        fill: #6a6e77;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M94.63,18.57h-6.08c-2.92,0-5.29-2.37-5.29-5.29V5.17h2.99v8.12c0,1.27,1.03,2.3,2.3,2.3h3.09V5.17h2.99v13.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M138.01,18.6h-2.99v-8.12c0-1.27-1.03-2.3-2.3-2.3h-3.09v10.42h-2.99V5.19h6.08c2.92,0,5.29,2.37,5.29,5.29v8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M117.88,18.71c-3.76,0-6.81-3.06-6.81-6.81s3.06-6.81,6.81-6.81,6.81,3.06,6.81,6.81-3.06,6.81-6.81,6.81ZM117.88,8.07c-2.11,0-3.82,1.71-3.82,3.82s1.71,3.82,3.82,3.82,3.82-1.71,3.82-3.82-1.71-3.82-3.82-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M68.89,18.71c-3.76,0-6.81-3.06-6.81-6.81s3.06-6.81,6.81-6.81,6.81,3.06,6.81,6.81-3.06,6.81-6.81,6.81ZM68.89,8.07c-2.11,0-3.82,1.71-3.82,3.82s1.71,3.82,3.82,3.82,3.82-1.71,3.82-3.82-1.71-3.82-3.82-3.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6a6e77",
    x: 77.61,
    y: 0.01,
    width: 3.15,
    height: 18.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6a6e77",
    x: 106.04,
    y: 5.06,
    width: 3.15,
    height: 13.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6a6e77",
    cx: 107.6,
    cy: 2.08,
    r: 1.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M104.1,8.07v-2.99h-3.92V1.81h-2.99v12.02c0,2.61,2.13,4.74,4.74,4.74h2.18v-2.99h-2.18c-.96,0-1.75-.78-1.75-1.75v-5.76h3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M147.39,18.71h-6.69v-2.99h6.69c.55,0,.99-.45.99-.99,0-.62-.52-1.3-.99-1.3h-2.75c-2.46,0-4.32-1.73-4.32-4.02s1.94-4.32,4.32-4.32h6.32v2.99h-6.32c-.74,0-1.33.6-1.33,1.33,0,.98,1.11,1.03,1.33,1.03h2.75c2.12,0,3.98,2,3.98,4.29s-1.79,3.98-3.98,3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M55.14,18.58h-6.62v-2.99h6.62c1.17,0,2.42-.59,2.42-1.69,0-.96-.65-1.8-1.57-2.04l-4.19-1.04c-2.13-.57-3.6-2.48-3.6-4.66,0-2.65,2.16-4.81,4.81-4.81h7.15v2.99h-7.15c-1,0-1.82.82-1.82,1.82,0,.82.56,1.55,1.35,1.76l4.19,1.04c2.26.6,3.82,2.63,3.82,4.94,0,2.67-2.32,4.68-5.41,4.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M26.6,18.62h-4.49c-4.77,0-8.66-3.88-8.66-8.65S17.33,1.31,22.11,1.31h4.49v2.99h-4.49c-3.12,0-5.67,2.54-5.67,5.66s2.54,5.66,5.67,5.66h4.49v2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M40.94,18.62h-4.9c-4.77,0-8.65-3.88-8.65-8.65S31.27,1.31,36.04,1.31h4.97v2.99h-4.97c-3.12,0-5.66,2.54-5.66,5.66s2.54,5.66,5.66,5.66h1.91v-5.73h2.99v8.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M6.95,18.58H.33v-2.99h6.62c1.17,0,2.42-.59,2.42-1.69,0-.96-.65-1.8-1.57-2.04l-4.19-1.04c-2.13-.57-3.6-2.48-3.6-4.66C0,3.5,2.16,1.34,4.81,1.34h7.15v2.99h-7.15c-1.01,0-1.82.82-1.82,1.82,0,.82.56,1.55,1.35,1.76l4.19,1.04c2.26.6,3.82,2.63,3.82,4.94,0,2.67-2.32,4.68-5.41,4.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M245.29,18.59h-2.99v-8.12c0-1.27-1.03-2.3-2.3-2.3h-3.09v10.42h-2.99V5.18h6.08c2.92,0,5.29,2.37,5.29,5.29v8.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6a6e77",
    x: 213.12,
    width: 3.15,
    height: 18.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M184.24,5.18h-3.09V0h-2.99v18.59h2.99v-10.42h3.09c1.27,0,2.3,1.03,2.3,2.3v8.12h2.99v-8.12c0-2.92-2.37-5.29-5.29-5.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6a6e77",
    x: 207.5,
    y: 5.04,
    width: 3.15,
    height: 13.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M209.07,3.79c.95,0,1.73-.77,1.73-1.73s-.77-1.73-1.73-1.73-1.73.77-1.73,1.73.77,1.73,1.73,1.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M253.79,18.71c-3.71,0-6.73-3.02-6.73-6.73s3.02-6.73,6.73-6.73h3.78V.11h2.99v11.83c0,3.73-3.04,6.77-6.77,6.77ZM253.79,8.25c-2.06,0-3.74,1.68-3.74,3.74s1.68,3.74,3.74,3.74,3.78-1.69,3.78-3.78v-3.69h-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M231.7,11.91v6.68h-6.77c-3.71,0-6.73-3.02-6.73-6.73,0-3.71,3.02-6.73,6.73-6.73s6.77,3.04,6.77,6.77ZM228.71,15.6v-3.69c0-2.08-1.69-3.78-3.78-3.78s-3.74,1.68-3.74,3.74,1.68,3.74,3.74,3.74h3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M205.21,11.91v6.68h-6.77c-3.71,0-6.73-3.02-6.73-6.73s3.02-6.73,6.73-6.73,6.77,3.04,6.77,6.77ZM202.22,15.6v-3.69c0-2.08-1.69-3.78-3.78-3.78s-3.74,1.68-3.74,3.74c0,2.06,1.68,3.74,3.74,3.74h3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M168.08,4.26h-4.99V1.31h13.13v2.95h-4.99v14.33h-3.14V4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M158.06,18.66c-.27-.5-.52-1.08-.74-1.73-.22-.66-.4-1.37-.54-2.13s-.26-1.56-.34-2.38c-.08-.82-.13-1.66-.13-2.51s.04-1.68.13-2.51c.08-.82.2-1.61.34-2.37.14-.76.32-1.46.54-2.12.22-.66.47-1.24.74-1.73h3.13c-.29.51-.55,1.11-.79,1.78-.24.67-.44,1.39-.6,2.14s-.28,1.54-.37,2.36c-.09.82-.13,1.63-.13,2.45s.04,1.64.13,2.46c.09.82.22,1.61.39,2.37.17.76.37,1.47.6,2.14.23.67.49,1.27.78,1.78h-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M262.88,18.66c.29-.51.55-1.11.78-1.78.23-.67.43-1.39.6-2.14.17-.75.3-1.54.39-2.37.09-.82.14-1.64.14-2.46s-.04-1.63-.14-2.45c-.09-.82-.21-1.6-.37-2.36s-.36-1.47-.59-2.14c-.23-.67-.5-1.27-.8-1.78h3.13c.27.5.52,1.08.74,1.73.22.66.4,1.36.54,2.12.14.76.26,1.55.34,2.37.08.83.13,1.66.13,2.51s-.04,1.68-.13,2.51c-.08.82-.2,1.62-.34,2.38s-.32,1.47-.54,2.13-.47,1.24-.74,1.73h-3.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M293.34,8.07v-2.99h-3.92V1.81h-2.99v12.02c0,2.61,2.13,4.74,4.74,4.74h2.18v-2.99h-2.18c-.96,0-1.75-.78-1.75-1.75v-5.76h3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M302.17,18.71c-3.71,0-6.73-3.02-6.73-6.73s3.02-6.73,6.73-6.73h3.78V.11h2.99v11.83c0,3.73-3.04,6.77-6.77,6.77ZM302.17,8.25c-2.06,0-3.74,1.68-3.74,3.74s1.68,3.74,3.74,3.74,3.78-1.69,3.78-3.78v-3.69h-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M273.04,1.34h3.14v14.29h8.14v2.94h-11.27V1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M312.68,18.71c-.48,0-.88-.16-1.18-.48s-.45-.7-.45-1.16.15-.84.45-1.16.7-.48,1.18-.48.86.16,1.17.48.47.7.47,1.16-.16.84-.47,1.16-.7.48-1.17.48Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupScgSolutionsThailandLtd);
export default __webpack_public_path__ + "static/media/group_SCG_Solutions(Thailand)Ltd.e5a0b7d91dd35454cd7fa16ca47bec8e.svg";
export { ForwardRef as ReactComponent };